<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show.sync="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :scrollable="true"
  >
    <div class="row d-flex">
      <!--Search Filtro -->  
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="input-group input-group">
          <span class="input-group-text text-white bg-main"
            ><i class="fas fa-search"></i
          ></span>
          <input
            v-model="search"
            type="text"
            class="form-control form-control"
            placeholder="Buscar Producto"
            @keyup="calculateData()"
          />
        </div>
      </div>  

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
          <div class="col-md-12 table-responsive" id="div-tabla-anular">
              <table id="tb-anular" class="table table-bordered text-xs">
                  <caption class="mx-0 px-0"></caption>
                  <thead class="bg-main">
                      <tr class="text-white text-center align-middle">
                        <th scope="col">N°</th>
                        <th scope="col">LOTE</th>
                        <th scope="col">PRODUCTO</th>
                        <th scope="col">CANTIDAD</th>
                        <th scope="col" class="nowrap">ESTADO</th>
                      </tr>
                  </thead>
                  <tbody class="border-main">
                    <tr v-if="cpData.length === 0" class="text-center">
                      <td colspan="4">No hay datos disponibles</td>
                    </tr>
                    <tr v-for="(det, index) in cpData" :key="index" class="text-center align-middle">
                      <template>
                        <td class="fw-semibold">{{ index + 1 }}</td>
                        <td>{{ det.lote}}</td>
                        <td>{{ det.product}}</td>
                        <td>{{ det.quantity_destination}}</td>
                        <td>
                          <span :style="badgeStyle(det.anulation_state)">
                            {{ stateAnnular(det.anulation_state) }}
                          </span>
                        </td>
                      </template>
                    </tr>
                  </tbody>
              </table>
          </div>

      </div>
    </div>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import { mapActions } from "vuex";
export default {
  name: "c-Pharmacy-cModalMovDetail",
  components: {
    CModal,
  },
  data() {
    return {
      search: "",
      tabla: [],
      // Estado de orden
      sortKey: '',
      sortOrder: '',
    };
  },
  created() {
  },
  computed: {
    cpData() {
      return this.tabla;
    },
  },
  watch: {
    item: {
      handler(newVal) {
        this.tabla = newVal; 
      },
      immediate: true,
    },
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id: Number,
    item: [],
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdClose() {
      this.mtdClear();
      this.$emit("mtdClose");
    },

    mtdClear() {
      this.search = "",
      this.tabla = []
    },

    calculateData() {
      if (this.search.length >= 2 && this.search.trim() !== "") {
        const query = this.search.toUpperCase();
        this.tabla = this.item.filter((element) => {
          const product = element.product ? element.product.toString().toUpperCase() : "";
          return product.includes(query);
        });
      } else {
        this.tabla = this.item;
      }
    },

    sortData(key, order) {
        if (this.sortKey && this.sortKey !== key) {
            this.sortOrder = ''; 
        }
        this.sortKey = key;
        this.sortOrder = order;

        this.item.sort((a, b) => {
            let result = 0;
            const valueA = a[key];
            const valueB = b[key];

            if (valueA < valueB) result = -1;
            if (valueA > valueB) result = 1;

            return order === 'asc' ? result : -result;
        });
    },

    //Annular
    stateAnnular(item) {
      switch (item) {
        case 0:
          return "Activo";
        case 1:
          return "Pendiente Anulación";
        case 2:
          return "Anulado";
        case 3:
          return "Anulado Parcial";
        case 4:
          return "Anulación Rechazada";
        case 5:
          return "No se pudo Anular";
        default:
          return "-";
      }
    },

    badgeStyle(state) {
      const colors = {
        0: { background: "green", color: "white" }, // Verde
        1: { background: "blue", color: "white" }, // Azul
        2: { background: "yellow", color: "black" }, // Amarillo
        3: { background: "orange", color: "white" }, // Naranja
        4: { background: "red", color: "white" }, // Rojo
        5: { background: "lightblue", color: "black" }, // Celeste
        default: { background: "gray", color: "white" }, // Plomo
      };
      return {
        padding: "2px 5px",
        borderRadius: "5px",
        fontWeight: "bold",
        fontSize: "11px",
        display: "inline-block",
        ...colors[state] || colors.default,
      };
    },
  },
};
</script>
<style scoped>
.align-middle{
  vertical-align: middle;
}
</style>
